import * as React from 'react';
import { ArrowUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/** Show after the user has scrolled roughly one short viewport of content. */
const SHOW_AFTER_PX = 400;

/**
 * Fixed “return to top” FAB for authenticated React admin pages.
 * Stacks above the feedback widget; window/document owns scroll.
 */
export function ScrollToTopButton() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const update = () => {
      setVisible(window.scrollY >= SHOW_AFTER_PX);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  function scrollToTop() {
    const reduceMotion =
      typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  return (
    <div
      data-scroll-to-top=""
      className={cn(
        'scroll-to-top-button pointer-events-none fixed bottom-[4.75rem] right-4 z-40',
        !visible && 'invisible',
      )}
      aria-hidden={!visible}
    >
      <Button
        type="button"
        size="icon"
        variant="outline"
        className={cn(
          'pointer-events-auto h-11 w-11 rounded-full bg-background/95 shadow-md backdrop-blur-sm',
          !visible && 'pointer-events-none',
        )}
        aria-label="Return to top"
        tabIndex={visible ? 0 : -1}
        onClick={scrollToTop}
      >
        <ArrowUp className="h-5 w-5" />
      </Button>
    </div>
  );
}
